module.exports = __webpack_public_path__ + "img/season_winter.24cd8db8.svg";